<table class="data-table">
  <thead>
    <tr>
      <th scope="col">
        <span class="icon-title">{{ 'FlexEdCtrl_Date' | translate }}</span>
      </th>
      <th scope="col">
        <span class="icon-title">{{
          'FlexEdCtrl_Description' | translate
        }}</span>
      </th>
      <th scope="col" class="right-text">
        <span class="icon-title">{{ 'FlexEdCtrl_Amount' | translate }}</span>
      </th>
    </tr>
  </thead>
  <tbody>
    <tr
      *ngFor="let transaction of transactionHistory"
      data-dgat="User-Index-1da"
    >
      <td>{{ transaction.transactionTime | date: 'longDate' }}</td>
      <td>{{ transaction.description }}</td>
      <td class="right-text">
        <span [innerHTML]="transaction.amount | dgxCurrency: 2"></span>
      </td>
    </tr>
  </tbody>
</table>
